module.exports = __webpack_public_path__ + "img/spitter-attack-5.02eb4b61.png";